import { TrashCan } from '@carbon/icons-react';
import { useTheme } from '@repo/theme';
import { FunctionalModal } from 'component/modal/functional-modal';
import { t } from 'util/stdtypes';

export function DeleteCommentModal({ onClose, onConfirm }: { onClose: () => void; onConfirm: () => void }) {
    const { colors } = useTheme();
    return (
        <FunctionalModal
            headingLabel={t('comment.delete_modal_heading', 'Are you sure you want to delete this post?')}
            onClose={onClose}
            primaryButton={{
                label: t('comment.delete_button', 'Delete'),
                icon: <TrashCan style={{ fill: colors.colorTextWarning }} />,
                testID: 'confirm-delete',
                type: 'delete',
                onPress: onConfirm,
            }}
            secondaryButton={{
                label: t('modal.cancel_button', 'Cancel'),
                onPress: onClose,
            }}
            subheadingLabel={t('comment.delete_modal_warning', "This action can't be undone.")}
        />
    );
}
